import React, { useState } from 'react'
import { CATALOG_FILTER } from 'lib/core/resources/constants'
import { ReactComponent as Chevron } from 'lib/core/resources/svg/chevron-down.svg'
import { ChangeFilterHandler, FilterOptions, getPriceFilterRange, LayeredPriceFilter } from 'lib/modules/catalog'

interface Props {
  isFetching: boolean
  filterOptions: FilterOptions
  handleFilterChange: ChangeFilterHandler
}

export const Filter = ({ filterOptions, handleFilterChange, isFetching }: Props) => {
  const {
    code,
    items,
    name,
    selected,
    settings
  } = filterOptions

  const [toggle, setToggle] = useState(Boolean(settings?.collapsed))
  const isPriceFilter = code === CATALOG_FILTER.PRICE
  const priceRange = isPriceFilter ? getPriceFilterRange(items) : undefined

  if (!items.length) {
    return null
  }

  if (isPriceFilter && !priceRange) {
    return null
  }

  const className = toggle ? 'isClosed' : undefined

  return (
    <li key={code}>
      <div
        onClick={() => setToggle(toggle => !toggle)}
      >
        <strong>
          <span>{name}</span>
          <Chevron className={className} />
        </strong>
      </div>
      <div className={className}>
        {priceRange ? (
          <LayeredPriceFilter
            minRange={priceRange[0]}
            maxRange={priceRange[1]}
            isFetching={isFetching}
            onChange={(e) => {
              handleFilterChange({
                requestVar: code,
                value: [e]
              })
            }}
            value={selected?.[0].value}
          />
        ) : (
          <>
            {items.map((item) => {
              return (
                <div key={`f-${item.requestVar}-${item.value}`}>
                  <label>
                    <input
                      type='checkbox'
                      checked={Boolean(selected?.find(el => el.value === item.value))}
                      value={item.value}
                      onChange={(e) => {
                        handleFilterChange({
                          requestVar: item.requestVar,
                          value: [item.value],
                          conf: {
                            multiple: true
                          }
                        })
                      }}
                    />
                    <span>{item.label}</span>
                  </label>
                </div>
              )
            })}
          </>
        )}
      </div>
    </li>
  )
}
